import { getAuthAxiosBackend } from "@/helpers/axios"

class PreviousEmploymentServices{

    get(id){
        return getAuthAxiosBackend().get('PreviousEmployment/getPreviousEmployment/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('PreviousEmployment/getPreviousEmploymentByPersonId/' + personId.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('PreviousEmployment/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('PreviousEmployment/addPreviousEmployment', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('PreviousEmployment/updatePreviousEmployment/' + id.toString(), data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('PreviousEmployment/softDeletePreviousEmployment/' + id.toString())
    }
}

export default new PreviousEmploymentServices()